import type {
  GetReferralPromoCode,
  PostApplyPromoCode,
  PostCheckPromoCode,
  PostSalonSuggestion,
} from "@/server-types";
import { get, post } from "../request-helpers";
import { useCustomMutation } from "../custom-mutation";
import { useCustomQuery } from "../custom-query";

const REFERRAL_PROMO_CODE_QUERY_KEY = ["referralPromoCode"];

/**
 * POST /user/promo-code/check — works before sign-up as well as after.
 */
export const useCheckPromoCode = () => {
  return useCustomMutation({
    mutationFn: (body: PostCheckPromoCode["body"]) =>
      post<PostCheckPromoCode>("/user/promo-code/check", body),
  });
};

/**
 * POST /promoCode/apply
 */
export const useApplyPromoCode = () => {
  return useCustomMutation({
    mutationFn: (body: PostApplyPromoCode["body"]) =>
      post<PostApplyPromoCode>("/promoCode/apply", body),
  });
};

/**
 * GET /promoCode/referral — the account's referral code and offer.
 */
export const useGetReferralPromoCode = (options?: { enabled?: boolean }) => {
  return useCustomQuery({
    queryKey: REFERRAL_PROMO_CODE_QUERY_KEY,
    queryFn: () => get<GetReferralPromoCode>("/promoCode/referral"),
    enabled: options?.enabled ?? true,
  });
};

/**
 * POST /promoCode/referral/salon-suggestion
 */
export const usePostSalonSuggestion = () => {
  return useCustomMutation({
    mutationFn: (body: PostSalonSuggestion["body"]) =>
      post<PostSalonSuggestion>("/promoCode/referral/salon-suggestion", body),
    displayNotification: true,
  });
};
